import { render, staticRenderFns } from "./ModuleInstaller.vue?vue&type=template&id=7864c556&"
import script from "./ModuleInstaller.vue?vue&type=script&lang=js&"
export * from "./ModuleInstaller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports